import React from "react";
import { FormControl, Checkbox } from "react-bootstrap";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./date-picker.css";
import TimezonePicker from "react-bootstrap-timezone-picker";
import "react-bootstrap-timezone-picker/dist/react-bootstrap-timezone-picker.min.css";
import timezones from "./data/timezones.json";

export default props => {
  if (props.type === "time") {
    const { type, value, ...otherProps } = props;
    const timeComponents = value.split(":");
    const time = moment()
      .hour(timeComponents[0])
      .minute(timeComponents[1]);
    return (
      <DatePicker
        {...otherProps}
        selected={time}
        value={time.format("hh:mm A")}
        className="form-control"
        showTimeSelect
        showTimeSelectOnly
        timeIntervals={15}
        dateFormat="LT"
        timeCaption="Time"
      />
    );
  }
  if (props.type === "timeZone") {
    const { type, ...otherProps } = props;
    return (
      <TimezonePicker
        {...otherProps}
        absolute={false}
        defaultValue=""
        placeholder="Select timezone..."
        overflow="visible"
        value={props.value}
        timezones={timezones}
      />
    );
  }
  if (props.type === "checkbox") {
    const { value, ...otherProps } = props;
    return <Checkbox checked={value} {...otherProps} />;
  }
  if (props.type === "select") {
    const { options, ...otherProps } = props;
    return (
      <FormControl componentClass="select" {...otherProps}>
        <option disabled value="-1">
          {" "}
          -- select an option --{" "}
        </option>
        {options.map(({ id, name }) => {
          return (
            <option key={id} value={id}>
              {name}
            </option>
          );
        })}
      </FormControl>
    );
  }
  /*
     {type === 'select' && <FormControl componentClass={type} {...props}>
     <option value = "">-select-</option>
     {options.map(({id,name}) => {
     return (<option key={id} value={id}>{name}</option>)
     })}
     </FormControl> }
     */
  return <FormControl {...props} />;
};



// WEBPACK FOOTER //
// ./src/sc/ui/components/FormControl.js